import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

function AdminDashboard() {
  const [contacts, setContacts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const contactsPerPage = 500;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const token = localStorage.getItem('access_token'); // Get the JWT token from localStorage
        const response = await fetch('/api/admin/contacts', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`, // Include JWT in the request headers
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setContacts(data);
        } else {
          console.error('Failed to fetch contacts.');
        }
      } catch (error) {
        console.error('Error fetching contacts:', error);
      }
    };

    fetchContacts();
  }, []);

  // Pagination logic
  const indexOfLastContact = currentPage * contactsPerPage;
  const indexOfFirstContact = indexOfLastContact - contactsPerPage;
  const currentContacts = contacts.slice(indexOfFirstContact, indexOfLastContact);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto py-20">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

      {/* List of contacts with pagination */}
      <div className="mb-8">
        <h2 className="text-xl font-bold">Contacts</h2>
        <ul>
          {currentContacts.map((contact) => (
            <li key={contact.id} className="mb-4 flex items-center">
              <button
                onClick={() => navigate(`/contacts/${contact.id}`)}
                className="text-blue-600 underline"
              >
                {contact.streetAddress}, {contact.city} ({contact.email})
              </button>

              {/* Display phone and email icons with color */}
              <div className="ml-4 flex items-center space-x-4">
                {/* Phone icon */}
                <FontAwesomeIcon
                  icon={faPhone}
                  className={`text-lg ${contact.contactedByPhone ? 'text-green-500' : 'text-red-500'}`}
                />

                {/* Email icon */}
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className={`text-lg ${contact.contactedByEmail ? 'text-green-500' : 'text-red-500'}`}
                />
              </div>
            </li>
          ))}
        </ul>

        {/* Pagination */}
        <div className="flex justify-center mt-6">
          {Array(Math.ceil(contacts.length / contactsPerPage))
            .fill()
            .map((_, index) => (
              <button
                key={index + 1}
                onClick={() => paginate(index + 1)}
                className={`mx-1 px-3 py-1 rounded ${currentPage === index + 1 ? 'bg-indigo-600 text-white' : 'bg-gray-200'}`}
              >
                {index + 1}
              </button>
            ))}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;

